import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMoreOpen, setIsMoreOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <nav className={`ucf-navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        {/* Left Menu */}
        <div className="nav-left">
          <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
            Home
          </Link>
          <Link to="/im-new" className={`nav-link ${isActive('/im-new') ? 'active' : ''}`}>
            I'm New
          </Link>
          <Link to="/events" className={`nav-link ${isActive('/events') ? 'active' : ''}`}>
            Events
          </Link>
        </div>

        {/* Center Logo */}
        <Link to="/" className="nav-logo">
          <img 
            src="https://customer-assets.emergentagent.com/job_8c6b9da3-c7cf-481c-ab7e-ed71573e5780/artifacts/3akixpjr_ucf.png" 
            alt="United Christian Fellowship" 
            className="logo-img"
          />
          <span className="nav-org-title">United Christian Fellowship</span>
        </Link>

        {/* Right Menu */}
        <div className="nav-right">
          <Link to="/watch-live" className="nav-link cta-link">
            Watch Live
          </Link>
          <Link to="/sermons" className={`nav-link ${isActive('/sermons') ? 'active' : ''}`}>
            Sermons
          </Link>
          <Link to="/contact" className={`nav-link ${isActive('/contact') ? 'active' : ''}`}>
            Contact
          </Link>
          
          {/* More Dropdown */}
          <div className="nav-more-dropdown">
            <button 
              className="nav-link more-btn" 
              onClick={() => setIsMoreOpen(!isMoreOpen)}
            >
              More <ChevronDown size={16} />
            </button>
            {isMoreOpen && (
              <div className="dropdown-menu">
                <Link to="/media" className="dropdown-item" onClick={() => setIsMoreOpen(false)}>
                  Media
                </Link>
                <Link to="/prayer-request" className="dropdown-item" onClick={() => setIsMoreOpen(false)}>
                  Prayer Request
                </Link>
                <Link to="/about" className="dropdown-item" onClick={() => setIsMoreOpen(false)}>
                  About
                </Link>
                <Link to="/leadership" className="dropdown-item" onClick={() => setIsMoreOpen(false)}>
                  Leadership
                </Link>
              </div>
            )}
          </div>
        </div>

        {/* Mobile Menu Toggle */}
        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <Link to="/" className="mobile-link" onClick={() => setIsMobileMenuOpen(false)}>
            Home
          </Link>
          <Link to="/im-new" className="mobile-link" onClick={() => setIsMobileMenuOpen(false)}>
            I'm New
          </Link>
          <Link to="/events" className="mobile-link" onClick={() => setIsMobileMenuOpen(false)}>
            Events
          </Link>
          <Link to="/watch-live" className="mobile-link cta-mobile" onClick={() => setIsMobileMenuOpen(false)}>
            Watch Live
          </Link>
          <Link to="/sermons" className="mobile-link" onClick={() => setIsMobileMenuOpen(false)}>
            Sermons
          </Link>
          <Link to="/contact" className="mobile-link" onClick={() => setIsMobileMenuOpen(false)}>
            Contact
          </Link>
          <Link to="/media" className="mobile-link" onClick={() => setIsMobileMenuOpen(false)}>
            Media
          </Link>
          <Link to="/prayer-request" className="mobile-link" onClick={() => setIsMobileMenuOpen(false)}>
            Prayer Request
          </Link>
          <Link to="/about" className="mobile-link" onClick={() => setIsMobileMenuOpen(false)}>
            About
          </Link>
          <Link to="/leadership" className="mobile-link" onClick={() => setIsMobileMenuOpen(false)}>
            Leadership
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
